import { AuthorizedRoute } from 'Components/AppLayout';
import { SITE_PAGES } from 'Config';
import Admin from 'Pages/Admin';
import UserDetailsPage from 'Pages/Admin/Users/UserDetailsPage';
import Biobanks from 'Pages/Biobanks';
import Dashboard from 'Pages/Dashboard';
import Help from 'Pages/Help';
import { Route } from 'react-router';

export const brdRoutes = (
  <>
    <Route path={SITE_PAGES.HELP.path} element={<Help />} />

    <Route
      path={SITE_PAGES.DASHBOARD.path}
      element={
        <AuthorizedRoute requiredAuth={SITE_PAGES.DASHBOARD.requiredAuth}>
          <Dashboard />
        </AuthorizedRoute>
      }
    />

    <Route
      path='/bio-resource/*'
      element={
        <AuthorizedRoute requiredAuth={SITE_PAGES.BIOBANK_LANDING.requiredAuth}>
          <Biobanks />
        </AuthorizedRoute>
      }
    />

    <Route
      path='/admin/*'
      element={
        <AuthorizedRoute requiredAuth={SITE_PAGES.ADMIN_LANDING.requiredAuth}>
          <Admin />
        </AuthorizedRoute>
      }
    />

    <Route
      path='/my_profile'
      element={
        <AuthorizedRoute requiredAuth={SITE_PAGES.MY_PROFILE.requiredAuth}>
          <UserDetailsPage isMyAccountPage />
        </AuthorizedRoute>
      }
    />
  </>
);
